// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"DiscountOneProduct_pageHolder__3hj64","centerHolder":"DiscountOneProduct_centerHolder__3hQDf"};